"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../../../utils");

var _utils2 = require("./utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var DownIcon = require('@tencent/ixd-icons-react/dist').DownIcon;

var AccordionComponents = function AccordionComponents(props) {
  var className = props.className,
      _a = props.configuration,
      configuration = _a === void 0 ? [] : _a,
      RenderComponent = props.render,
      slot = props.slot,
      _b = props.defaultExplore,
      defaultExplore = _b === void 0 ? false : _b;
  var childrenNodes;
  var getHeightVal = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    (0, _utils.windowAddEventListener)(function (status) {
      if (!status) {
        (0, _utils2.checkTabInit)(getHeightVal, childrenNodes);
      }
    });
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('price-accordion-container', className)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "am-accordion"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: getHeightVal
  }, configuration === null || configuration === void 0 ? void 0 : configuration.map(function (item, i) {
    var title = item.title;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: 'price-list-tab',
      key: i
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('', {
        'price-am-accordion-item-leave': defaultExplore || i !== 0,
        'price-am-accordion-item': i === 0
      })
    }, /*#__PURE__*/_react["default"].createElement("div", __assign({
      style: configuration.length === 1 ? {
        display: 'none'
      } : {},
      className: (0, _classnames["default"])('price-a-am-accordion-title', {
        'price-list-tab--last-child': i === configuration.length - 1
      }),
      "aria-expanded": "false",
      onClick: function onClick() {
        (0, _utils2.checkTabsStatus)(i, getHeightVal);
      }
    }, item.extendProps || {}), slot ? slot(item, i) : /*#__PURE__*/_react["default"].createElement("strong", null, title), /*#__PURE__*/_react["default"].createElement(DownIcon, {
      className: 'd-icon'
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('price-a-am-accordion-container', {
        alone: configuration.length === 1
      })
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "price-a-am-accordion-content"
    }, /*#__PURE__*/_react["default"].createElement(RenderComponent, __assign({}, item || {}))))));
  }))));
};

AccordionComponents.propTypes = {
  className: _propTypes["default"].string,
  configuration: _propTypes["default"].array,
  render: _propTypes["default"].func,
  slot: _propTypes["default"].func,
  defaultExplore: _propTypes["default"].bool
};
var _default = AccordionComponents;
exports["default"] = _default;